import * as React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface IProps {
    show: boolean,
    description: string,
    onDelete: () => void,
    onCancel: () => void
}

const Delete = (props: IProps) => {
    return (
        <Modal show={props.show} onHide={props.onCancel}>
            <Modal.Header style={{ borderBottom: '0 none' }}>
                <h4 style={{ marginBottom: 0 }}>Are you sure you want to delete the following notification?</h4>
            </Modal.Header>
            <Modal.Body>
                <div className='text-center h3'>
                    {props.description}
                </div>
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '0 none' }}>
                <Button onClick={props.onCancel}>No, Cancel</Button>
                <Button bsStyle='danger' onClick={props.onDelete}>Yes, Delete</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default Delete;